module.exports = __webpack_public_path__ + "img/billing-code.b0e328b4.svg";